import '../../../vendor/pdf/browser';
import '../../../vendor/pdf/pdf';


function startZoom() {
    var icon = $('.icon');
    var frame = $('.frame');
    icon.on("click", function (e) {
        var target = e.currentTarget;
        frame.addClass('searchStart');
        if (frame.hasClass('searchStart')) {
            zoomCanvas();
        }
        $(document).on('mouseleave', '.searchStart', function () {
            $(document).off(zoomCanvas());
        });
    });

}

function zoomCanvas() {
    $(document).on('mousemove', '.frame', function () {
        var element = {
            width: $(this).width(),
            height: $(this).height()
        };

        var mouse = {
            x: event.pageX,
            y: event.pageY
        };

        var offset = $(this).offset();

        var origin = {
            x: (offset.left + (element.width / 2)),
            y: (offset.top + (element.height / 2))
        };

        var trans = {
            left: (origin.x - mouse.x) / 2,
            down: (origin.y - mouse.y) / 2
        };

        var transform = ("scale(2,2) translateX(" + trans.left + "px) translateY(" + trans.down + "px)");

        $(this).children("canvas").css("transform", transform);

    });

    $(document).on('mouseleave', '.frame', function () {
        $(this).children("canvas").css("transform", "none");
    });

}


function renderPage(page, container) {
    const options = {scale: 3};
    const PRINT_RESOLUTION = 300;
    const PRINT_UNITS = PRINT_RESOLUTION;

    const viewport = page.getViewport(options.scale);
    const wrapper = document.createElement('div');
    const canvas = document.createElement('canvas');
    const icon = document.createElement('div');

    wrapper.classList.add('frame');
    icon.classList.add('icon');
    wrapper.append(icon);
    wrapper.append(canvas);

    const ctx = canvas.getContext('2d');
    const renderContext = {
        canvasContext: ctx,
        viewport: viewport,
        transform: [PRINT_UNITS, 0, 0, PRINT_UNITS, 0, 0],
    };

    canvas.height = viewport.height;
    canvas.width = viewport.width;
    canvas.style.width = "100%";
    canvas.style.height = "100%";

    container.append(wrapper);

    page.render(renderContext).then(function () {
        startZoom();
    }, function () {
        console.log("error");
    });
}

function renderPages(pdfDoc, canvasContainer) {
    for (var num = 1; num <= pdfDoc.numPages; num++) {
        pdfDoc.getPage(num).then((page) => renderPage(page, canvasContainer));
    }
}

function renderPDF(url, canvasContainer) {
    PDFJS.disableWorker = true;
    PDFJS.getDocument(url).then((pdfDoc) => renderPages(pdfDoc, canvasContainer));
}

$('[data-pdf-viewer]').each((i, container) => {
    renderPDF($(container).attr('data-pdf-viewer'), container);
});
